import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';

function Navbar() {
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const closeDropdown = () => setIsDropdownOpen(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <a href="#inicio">
            <img src="images/logo/Logo Moti.svg" alt="Moti" />
          </a>
        </div>

        {/* Menú hamburguesa */}
        <div
          className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </div>

        {/* Menú principal */}
        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <a href="#inicio" className="navbar-link" onClick={closeMenu}>Inicio</a>
          </li>

            <li className="navbar-item">
            <a href="#/nosotros" className="navbar-link" onClick={closeMenu}>
              Nosotros
            </a>
          </li> 

          <li className="navbar-item">
            <a href="#/Tag" className="navbar-link" onClick={closeMenu}>
              ElastiTag®
            </a>
          </li> 
          <li className="navbar-item">
            <a href="#tecnologias" className="navbar-link" onClick={closeMenu}>
              tecnologías
            </a>
          </li>

          {/* Dropdown Tienda en línea */}
          <li className="navbar-item dropdown" ref={dropdownRef}>
            <button
              className="navbar-link dropdown-toggle"
              onClick={toggleDropdown}
            >
              tienda en línea
            </button>

            {isDropdownOpen && (
              <ul className="dropdown-menu">
                <li>
                  <a
                    href="https://motistore.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/icons/motistore-icon.svg"
                      alt="Motistore"
                      className="dropdown-icon"
                    />
                    <div className="dropdown-text">
                      <span className="dropdown-subtitle">
                        Imprime todo para tu negocio
                      </span>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href="https://motifabrics.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/images/icons/motifabrics-icon.svg"
                      alt="Motifabrics"
                      className="dropdown-icon"
                    />
                    <div className="dropdown-text">
                      <span className="dropdown-subtitle">
                        Imprime la decoración de tu hogar
                      </span>
                    </div>
                  </a>
                </li>
              </ul>
            )}
          </li>

          <li className="navbar-item">
            <a href="#productos" className="navbar-link" onClick={closeMenu}>
              productos y servicios
            </a>
          </li>
        </ul>

        <div
          className={`menu-overlay ${isMenuOpen ? 'active' : ''}`}
          onClick={closeMenu}
        ></div>
      </div>
    </nav>
  );
}

export default Navbar;
